<template>
	<div class="pt-1 pb-3 position-relative">
    <p class="mb-0 mt-3 body-2-2 text-14 font-bold">{{$t('hotel.concierge.form.id-verification')}} :</p>
    <div class="my-3"></div>
    <p class="mb-2 body-2-1 font-regular">{{$t('hotel.concierge.form.how-many-guest-stay')}}</p>
    <div class="mb-3 border-top border-bottom overflow-hidden mb-2" style="padding: 12px 0px 10px">
      <div class="div-wrapper mx-auto d-inline-block m-width-100 w-people" id="guest" style="width: 97%">
        <div style="width: max-content">
          <div class="w-60px border rounded-6 text-center d-inline-block mx-1 cursor-pointer" :class="{'bg-green':selected_qty == index}" v-for="index in max_guest" @click="selectTotalGuest(index)">
            <p class="body-1 m-3 mt-1" :class="{'text-white':selected_qty == index}">{{index}}</p>
          </div>
        </div>
      </div>
    	<!-- DIRECTION -->
    	<template v-if="max_guest > 6">
	      <div class="mobile-none width-60 text-center d-inline-block position-absolute bg-smoth-light cursor-pointer" style="width: 20px;left: 0" @click="xScroll('left', 'guest')">
	        <img src="../../../../assets/img/icon/green-arrow-left.png" width="18" class="next-button position-relative" style="left: -15px;z-index: 9;top: 15px;">
	      </div>
	      <div class="mobile-none width-60 text-center d-inline-block bg-smoth-light position-absolute cursor-pointer" style="width: 20px;right: 0;" @click="xScroll('right', 'guest')">
	        <img src="../../../../assets/img/icon/green-arrow-right.png" width="18" class="next-button position-relative" style="right: -12px;z-index: 9;top: 15px;">
	      </div>
    	</template>
      <!-- <p class="body-2 text-12 mb-0">*Guest</p> -->
    </div>
		<p class="mb-3 body-2-1 font-regular">{{$t('hotel.concierge.form.please-attach-id')}}<span v-if="getMerchant.precheckin_form_document_verification == 'REQUIRED'" class="text-danger">*</span></p>
		<div class="text-center mb-4">
			<div class="w-100 d-block mb-3">
				<div class="row mb-3 pb-2 no-gutters" v-for="(img_data,img_i) in form">
					<div class="col-2 align-self-center">
						<div class="w-90" style="height: 35px;">
							<img :src="img_data.preview" class="img-fit rounded-3">
						</div>
					</div>
					<div class="col-9 text-left align-self-center">
						<div class="px-2">
							<p class="mb-0 body-3-3-2">{{ img_data.file.name }}</p>
							<p class="mb-0 body-3">{{ formatBytes(img_data.file.size) }}</p>
						</div>
					</div>
					<div class="col-1 align-self-center text-right cursor-pointer" @click="cancelImage(img_i)">
						<svg class="lh-1" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<g id="close_24px">
								<path id="icon/navigation/close_24px" d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#DC3545"/>
							</g>
						</svg>
					</div>
				</div>
				<div v-if="error_form != ''" class="w-100 mb-3">
					<ErrorMessage :message="error_form"></ErrorMessage>
				</div>
				<div class="w-100" v-if="form.length < max_guest">
					<input id="form_file" accept=".png, .jpg, .jpeg, .webp, .gif, .jfif" type="file" name="filefield" multiple="multiple" @change="handleFileChangeMultiple($event)" class="d-none">
					<label for="form_file" class="cursor-pointer w-100">
						<div class="w-100 bg-light-page border-2-dashed-primary radius-12 text-center" :class="form.length == 0? 'py-4':'py-3'">
							<template v-if="form.length == 0">
								<svg class="lh-1" width="47" height="40" viewBox="0 0 47 40" fill="none" xmlns="http://www.w3.org/2000/svg">
									<g clip-path="url(#clip0_360_18)">
										<path
											d="M9.83876 32.8264L34.572 28.4681C38.3418 27.7877 39.9233 25.5627 39.2612 21.8481L36.2454 4.76467C35.6018 1.03169 33.3584 -0.512993 29.5887 0.149014L4.83693 4.50723C1.04878 5.18762 -0.514286 7.3943 0.147721 11.1273L3.16352 28.2108C3.80715 31.9437 6.03222 33.4884 9.83876 32.8264ZM9.36064 29.9025C7.55851 30.2151 6.38161 29.4244 6.05061 27.5487L3.08997 10.7779C2.75897 8.88382 3.58647 7.7437 5.40699 7.41269L30.0483 3.07287C31.832 2.77864 33.0274 3.55099 33.3584 5.42667L36.319 22.1974C36.6684 24.0916 35.8041 25.2316 34.0204 25.5627L9.36064 29.9025Z"
											class="fill-primary" />
										<path
											d="M15.9807 38.6189H41.1185C44.9434 38.6189 46.8743 36.7064 46.8743 32.9184V15.5774C46.8743 11.7893 44.9434 9.87682 41.1185 9.87682H15.9807C12.1374 9.87682 10.2249 11.7893 10.2249 15.5774V32.9184C10.2249 36.7249 12.1374 38.6189 15.9807 38.6189Z"
											fill="white" />
										<path
											d="M15.9807 38.6189H41.1185C44.9434 38.6189 46.8743 36.7064 46.8743 32.9184V15.5774C46.8743 11.7893 44.9434 9.87682 41.1185 9.87682H15.9807C12.1374 9.87682 10.2249 11.7893 10.2249 15.5774V32.9184C10.2249 36.7249 12.1374 38.6189 15.9807 38.6189ZM16.0358 35.6583C14.197 35.6583 13.1856 34.6837 13.1856 32.7712V15.743C13.1856 13.8305 14.197 12.8375 16.0358 12.8375H41.0634C42.8839 12.8375 43.9137 13.8305 43.9137 15.743V32.7712C43.9137 34.6837 42.8839 35.6583 41.0634 35.6583H16.0358ZM16.0543 37.6443H40.6587C43.8769 37.6443 45.5686 36.026 45.5686 32.808V31.6311L37.0546 23.5766C36.3373 22.9147 35.4546 22.5836 34.5536 22.5836C33.6526 22.5836 32.8435 22.8778 32.0711 23.5582L24.6419 30.1415L21.6997 27.4751C20.9825 26.8316 20.2469 26.5374 19.4562 26.5374C18.7391 26.5374 18.0403 26.8316 17.3415 27.4384L11.1444 32.8264C11.1444 36.026 12.8545 37.6443 16.0543 37.6443Z"
											class="fill-primary" />
										<path
											d="M23.318 23.9813C25.4695 23.9813 27.2164 22.1974 27.2164 20.0459C27.2164 17.9312 25.4695 16.1475 23.318 16.1475C21.1665 16.1475 19.4378 17.9312 19.4378 20.0459C19.4378 22.1974 21.1665 23.9813 23.318 23.9813Z"
											class="fill-primary" />
									</g>
									<defs>
										<clipPath id="clip0_360_18">
											<rect width="46.8743" height="40" fill="white" />
										</clipPath>
									</defs>
								</svg>
								<p class="w-100 mt-3 body-2 mb-0">Click to upload</p>
							</template>
							<p v-else class="mb-0 body-4 text-green">Upload more</p>
						</div>
					</label>
				</div>
			</div>
			
			<div class="w-100" v-if="form.length > 1">
				<p class="mb-3 body-2-1 font-regular text-left">Which photo is your own ID card?</p>
				<div class="row slim-grid-row">
					<div class="col-4 mb-4" v-for="(img_data,img_i) in form">
						<div 
							class="w-100 mb-1 radius-6 p-2 border-form cursor-pointer position-relative" 
							:class="img_data.file.name == my_id.file.name ? 'border-2-green' : 'border-2-form'"
							style="height: 80px;" 
							@click="selectImageAsMe(img_data)">
							<img :src="img_data.preview" class="img-fit rounded-3">

							<div v-if="img_data.file.name == my_id.file.name" class="position-absolute" style="top:12px;right:12px;">
								<svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_553_23)">
                    <path
                      d="M13 26C20.1118 26 26 20.0991 26 13C26 5.88824 20.0991 0 12.9873 0C5.88824 0 0 5.88824 0 13C0 20.0991 5.90099 26 13 26Z"
                      class="fill-primary" />
                    <path
                      d="M11.5725 19.2324C11.1392 19.2324 10.7824 19.0539 10.451 18.6079L7.25197 14.6824C7.0608 14.4275 6.94609 14.1471 6.94609 13.854C6.94609 13.2804 7.39217 12.8088 7.9657 12.8088C8.33531 12.8088 8.61571 12.9235 8.93432 13.3441L11.5216 16.6833L16.9638 7.94021C17.2059 7.55786 17.5373 7.35394 17.8687 7.35394C18.4294 7.35394 18.952 7.73629 18.952 8.33531C18.952 8.61571 18.7863 8.90885 18.6334 9.17649L12.6432 18.6079C12.3755 19.0285 12.0059 19.2324 11.5725 19.2324Z"
                      fill="white" />
                  </g>
                  <defs>
                    <clipPath id="clip0_553_23">
                      <rect width="26" height="26.0128" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
							</div>
						</div>
						<p class="mb-0 body-3-3-2 text-truncate" :class="img_data.file.name == my_id.file.name ? 'text-green' : ''">{{ img_data.file.name }}</p>
						<p class="mb-0 body-3-3-2 text-orange cursor-pointer" @click="toggleDetail(img_data)">View Detail</p>
					</div>
				</div>
				<p class="mb-0 mt-3 body-3-3-1 text-danger" v-if="show_error && error.owner_img != ''">Please select wich one is your id</p>
			</div>
			
			<p class="mb-0 mt-3 body-3-3-1 text-danger" v-if="show_error && error.img != ''">{{$t('warning-message.precheckin.'+error.img)}}</p>
		</div>

		<b-modal 
      v-model="detail.show" 
      ref="product_detail" 
      centered size="lg"
			@hidden="toggleDetail()"
			 hide-footer >
			<img v-if="detail.show" class="w-100" :src="detail.data.preview">
		</b-modal>
  </div>
</template>
<script>
	import { mapGetters } from 'vuex'
	export default{
		props: {
			max_guest:{
				type: Number,
				default: 2
			},
			error:{
        type: Object,
        default: () => {}
      },
      show_error:{
        type: Boolean,
        default: false
      }
		},
		data(){
			return{
				selected_qty: 1,
				form: [],
				error_form: '',
				my_id: {
					file:{
						name: ''
					}
				},
				detail:{
					show: false,
					data: {}
				}
			}	
		},
		computed:{
			...mapGetters(['getMerchant']),
			form_length(){
				return this.form.length
			}
		},
		watch:{
			form_length(){
				let is_form_valid = this.form.length > 0
				let is_my_id_exist = this.form.some(x=>x.file.name == this.my_id.file.name)
				
				if(!is_form_valid || !is_my_id_exist){
					this.my_id = {
						file:{
							name: ''
						}
					}
				}
			}
		},
		mounted(){
			this.refreshForm()
		},
		methods:{
			selectTotalGuest(data){
				if(data != this.selected_qty){
					this.selected_qty = data	
					this.refreshForm()
				}
			},
			handleFileChange(evt,index){
				this.form[index] = {
					file: evt.target.files[0],
					preview: URL.createObjectURL(evt.target.files[0]),
					is_preview: true
				}
				this.refreshForm()
      },
			handleFileChangeMultiple(evt){
				// let max_loop = this.getMerchant.precheckin_form_total_document_verification == 'BASED_ON_TOTAL_GUEST' ? this.selected_qty : this.max_guest
				let max_loop = this.selected_qty
				let valid_loop_length = max_loop - this.form.length
				let total_loop = evt.target.files.length+this.form.length
				
				// if(this.getMerchant.precheckin_form_total_document_verification == 'BASED_ON_TOTAL_GUEST'){
					if(total_loop > this.selected_qty){
						this.error_form = `You may only upload ${this.selected_qty} photos`
						setTimeout(()=>{
							this.error_form = ''
						},3000)
					}else{
						this.error_form = ''
					}
				// }else if(this.getMerchant.precheckin_form_total_document_verification == 'MAX_ON_MAX_GUEST'){
				// 	if(total_loop > this.max_guest){
				// 		this.error_form = `You may only upload ${this.max_guest} photos`
				// 		setTimeout(()=>{
				// 			this.error_form = ''
				// 		},3000)
				// 	}
				// }

				for (let i = 0; i < valid_loop_length; i++) {
					if(i < evt.target.files.length){
						const el = evt.target.files[i];
						this.form.push({
							file: el,
							preview: URL.createObjectURL(el),
							is_preview: true
						})
					}else{
						break;
					}
				}
				this.refreshForm()
			},
			formatBytes(bytes, decimals) {
				if (bytes == 0) return '0 Bytes';
				var k = 1024,
					dm = decimals <= 0 ? 0 : decimals || 2,
					sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
					i = Math.floor(Math.log(bytes) / Math.log(k));
				return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
			},
      cancelImage(index){
				if(this.my_id.file.name == this.form[index].file.name){
					this.selectImageAsMe({
						file:{
							name: ''
						}
					})
				}
      	this.form.splice(index,1)
				this.refreshForm()
      },
      refreshForm(){
      	let temp = this.form 
				this.form = []
				this.form = temp
				this.$emit('fillData',{type: 'passport', data: this.form, other_data:this.selected_qty})
      },
      xScroll(type, id) {
        let content = document.querySelector("#" + id);
        if (type == 'left') {
          content.scrollLeft -= 80;
        } else {
          content.scrollLeft += 80;
        }
        console.log(content.scrollLeft)
      },
			selectImageAsMe(data){
				this.my_id = data
				this.$emit('fillData',{type: 'passport-owner', data: this.my_id})
			},
			toggleDetail(data=null){
				this.detail.show = data == null ? false : true
				this.detail.data = data == null ? {} : data
			}
		}
	}
</script>
<style scoped>
	.custom-close-img{
    position: absolute;
    top: -6px;
    right: -6px;
    height: 20px;
    width: 20px;
    padding: 4px;
    background-color: #3a3a3a;
    border-radius: 50%;
    border: 2px solid #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/hotel/concierge/checkin/UploadPassport.vue